// A SENT INVOICE IS CANCELLED, NEVER DELETED (UI-24 item 19, decision 2, Carla, 2026-10-20). The same
// question the server asks (Aidey Backend/lib/invoiceDeletable.js): sent_at is set, or the status is
// beyond draft (an invoice sent before sent_at existed). The screen offers "Cancel invoice" instead.
export function canDeleteInvoice(invoice) {
  if (!invoice) return false;
  if (invoice.sentAt != null) return false;
  return String(invoice.status || 'draft').trim().toLowerCase() === 'draft';
}
